import { Spin } from 'antd';
import React from 'react';
import './style.scss';

interface IProps {
    wrapperClassName?: string;
    size?: 'large' | 'small';
    isLoading: boolean;
    children?: React.ReactNode;
}

const LoadingWrap: React.FC<IProps> = ({ size = 'large', isLoading, children, wrapperClassName }) => {
    return (
        <Spin wrapperClassName={`hoangvy-loading ${wrapperClassName}`} size={size} spinning={isLoading}>
            {children}
        </Spin>
    );
};

export default React.memo(LoadingWrap);
